export default __webpack_public_path__ + "static/media/warrior.1a08f7cd.JPG";